import { Button } from '@pepper/ui'

function TryPepperCTA() {
  return (
    <>
      <Button
        type="ghost"
        onClick={() => {
          window.location.href = '/signup'
        }}
      >
        Try Pepper
      </Button>
      <Button
        type="primary"
        onClick={() => {
          window.location.href = '/login'
        }}
      >
        Log In
      </Button>
    </>
  )
}

export default TryPepperCTA
